import React, { useEffect, useState } from 'react';
import { Divider, Stack } from '@mui/material';

import { Pagination } from 'components/Pagination';
import { usePageSize } from 'hook/usePageSize';
import { NotFound } from 'components/NotFound/NotFound';
import { Loader } from 'components/Loader';
import { VersionCard } from './VersionCard';

const versionsTabName = 'versions';

export const VersionsTab = ({
  currentTab,
  versionsData,
  isFetching,
  page,
  setPage,
}) => {
  const [pageSize, setPageSize] = usePageSize();
  const [loading, setLoading] = useState(false);
  const [timer, setTimer] = useState(null);

  const { versions, total } = versionsData;

  const handlePageChange = (_, page) => setPage(page);

  useEffect(() => {
    if (isFetching) {
      const timeoutId = setTimeout(() => setLoading(true), 500);
      setTimer(timeoutId);
    } else {
      clearTimeout(timer);
      setTimeout(() => setLoading(false), 1000);
    }

    return () => clearTimeout(timer);
  }, [isFetching]);

  if (currentTab !== versionsTabName) return null;

  return (
    <>
      <Stack gap={2} height={1}>
        <Divider />

        {isFetching && !loading ? (
          <></>
        ) : !isFetching || (isFetching && loading) ? (
          <>
            {loading && <Loader />}

            {!loading && (
              <>
                <Stack gap={1} flex={1}>
                  {versions?.length === 0 && (
                    <NotFound
                      title="No versions found"
                      caption="This ad has no version history."
                      wrapperSx={{ mt: 19 }}
                    />
                  )}

                  {versions.map((version, index) => (
                    <VersionCard key={version.id + index} {...version} />
                  ))}
                </Stack>

                <Stack direction="row" justifyContent="center">
                  <Pagination
                    page={page}
                    handlePageChange={handlePageChange}
                    itemCount={total}
                    itemsPerPage={pageSize}
                    onItemsPerPageChange={setPageSize}
                  />
                </Stack>
              </>
            )}
          </>
        ) : (
          <></>
        )}
      </Stack>
    </>
  );
};

